import cn from 'classnames';
import type React from 'react';
import type { Control} from 'react-hook-form';
import { Controller } from 'react-hook-form';
import OtpInput from 'react-otp-input';

import * as st from './styles.module.scss';

interface Props {
	control: Control;
	disabled?: boolean;
	error: boolean;
	length?: number;
	tabindex: number;
}

const PasscodeControlled: React.FC<Props> = ({ control, error, length, disabled, tabindex }) => {
	return (
		<Controller
			name="passcode"
			render={({ field: { onChange, value } }) => {
				return (
					<div className={st.passcode}>
						<OtpInput
							value={value}
							onChange={onChange}
							renderInput={(props) => (
								<input
									tabIndex={tabindex}
									{...props}
									className={cn(st.passcode__input, error && st.passcode__error)}
								/>
							)}
						/>
					</div>
				);
			}}
			control={control}
		/>
	);
};

export default PasscodeControlled;
